export const LABEL_COLOR_ANALYTIC_SOURCE = 'labelColor';
